import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import './PageHeader.css';

const PageHeader = ({ title, subtitle, breadcrumb, showPeriod = true }) => {
    return (
        <div className="page-header">
            <div className="page-header-overlay"></div>
            <div className="container relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="page-header-content"
                >
                    <div className="breadcrumb">
                        <Link to="/" className="breadcrumb-link">Home</Link>
                        <ChevronRight size={14} className="breadcrumb-separator" />
                        <span className="breadcrumb-current">{breadcrumb || title}</span>
                    </div>

                    <h1 className="page-title">
                        {title}
                        {showPeriod && <span className="page-title-highlight">.</span>}
                    </h1>

                    {subtitle && (
                        <p className="page-subtitle">{subtitle}</p>
                    )}
                </motion.div>
            </div>
        </div>
    );
};

export default PageHeader;
